import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_CropImage = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/crop-image',
			name: 'Crop Images Online — Photo Cropper for Better Composition | Lift',
			description:
				'Crop images online instantly with Lift Photo Cropper. No watermark Upload your photo, crop it to any size or aspect ratio, and download in seconds. Try it today!',
			url: 'https://liftapp.ai/crop-image',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/crop-image#product' },
				{ '@id': 'https://liftapp.ai/crop-image#howto' },
				{ '@id': 'https://liftapp.ai/crop-image#benefits' },
				{ '@id': 'https://liftapp.ai/crop-image#faq' },
				{ '@id': 'https://liftapp.ai/crop-image#why-lift' },
				{ '@id': 'https://liftapp.ai/crop-image#explore-tools' },
				{ '@id': 'https://liftapp.ai/crop-image#all-in-one' },
			],
		},
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/crop-image#product',
			name: 'Online Image Cropper',
			description:
				'Crop images in seconds with our online photo cropper. Get perfectly framed photos for any platform or size — no watermarks, no installs.',
			url: 'https://liftapp.ai/crop-image',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/crop-image#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Crop Your Image',
					text: 'Drag and move the crop frame to adjust your photo.',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/crop-image#benefits',
			name: 'Who can benefit from the Image Cropper?',
			description:
				'Lift Image Cropper helps social media users, small business owners, e-commerce sellers, students, professionals, and content creators crop and resize images for any platform.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Social Media Users — Crop photos for Instagram, TikTok, or any platform in seconds with the exact aspect ratio you need.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Small Business Owners — Crop and resize images for ads, banners, and marketing materials without hiring a designer.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'E-commerce Sellers — Crop product photos to square or custom dimensions ready for Amazon, Etsy, or your online store.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Students & Professionals — Quickly crop images for presentations, reports, CVs, or passport-size photos.',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Content Creators — Reframe shots, crop pictures into shapes, or resize images to custom dimensions with pixel-perfect control.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'Lift Online Image Cropper',
				description:
					'Lift photo cropper and resizer online for social media, business, and design',
			},
		},
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/crop-image#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift Photo Cropper?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift Photo Cropper is a online cropping tool that lets you crop images, cut pictures to any size, and select custom aspect ratios — all in your browser. It works with JPEG, PNG, and other formats, and requires no software download. Whether you need to crop a photo for Instagram, resize an image with custom dimensions, or frame a shot for print, Lift makes it fast and easy.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift Photo Cropper work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Simply upload your photo from your device, choose a preset aspect ratio or set custom crop dimensions, then drag the crop frame to reframe your image. When you're happy with the result, preview the cropped picture in the browser and download your high-resolution file — no watermarks added.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I crop and resize images without losing quality?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Yes. Lift's online image cropper is designed to preserve the original resolution of your photo within the cropped area. You can crop and resize your image to custom dimensions or standard aspect ratios without any degradation in quality. The result is a sharp, high-resolution file ready for social media, print, or professional use.",
					},
				},
				{
					'@type': 'Question',
					name: 'Is it safe — do you store my images?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes, completely safe. Your images are processed securely and automatically deleted from our servers immediately after compression. We never store, share, or access your files — your privacy is our priority.',
					},
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/crop-image#why-lift',
			name: 'Why Lift Photo Cropper',
			description:
				'High-quality results, intelligent rendering, cross-platform support, and budget-friendly pricing.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Lift Online Photo Cropper',
				description:
					'Best image cropper and resizer online — quality, speed, and cross-platform support',
			},
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/crop-image#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/crop-image#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},
		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Image Cropper',
					item: 'https://liftapp.ai/crop-image',
				},
			],
		},
	],
};
